import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Stepper from "../../components/Stepper";
import { auth } from "../../firebase";
import { useParams } from "react-router-dom";

const FUNCTION_URL =
  "https://southamerica-east1-feirateste-279c6.cloudfunctions.net/cadastrarExpositor";
const RECAPTCHA_SITE_KEY = "6LcK-GssAAAAAKSe6hUW_OGIFlpJbUo83vPIKYeZ";

export default function CadastroExpositor() {
  const [nome, setNome] = useState("");
  const [cpf, setCpf] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [sucesso, setSucesso] = useState(false);
  const [erroTermos, setErroTermos] = useState("");
  const [loading, setLoading] = useState(false);
  const [recaptchaWidgetId, setRecaptchaWidgetId] = useState(null);
  const { id: eventoId } = useParams();

  // ===== NOVO =====
  const [isAdmin, setIsAdmin] = useState(false);

  const navigate = useNavigate();

  // ===== VERIFICAÇÃO ADMIN =====
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (!user) {
        setIsAdmin(false);
        return;
      }

      const idTokenResult = await user.getIdTokenResult(true);
      console.log("CLAIMS:", idTokenResult.claims);

      setIsAdmin(!!idTokenResult.claims.admin);
    });

    return () => unsubscribe();
  }, []);

  // ===== RECAPTCHA =====
  useEffect(() => {
    if (isAdmin) return;

    if (!document.getElementById("recaptcha-script")) {
      const script = document.createElement("script");
      script.id = "recaptcha-script";
      script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }

    const interval = setInterval(() => {
      const container = document.getElementById("recaptcha-container");

      if (
        window.grecaptcha &&
        window.grecaptcha.render &&
        container &&
        recaptchaWidgetId === null
      ) {
        const id = window.grecaptcha.render(container, {
          sitekey: RECAPTCHA_SITE_KEY,
          size: "invisible",
        });

        setRecaptchaWidgetId(id);
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [recaptchaWidgetId, isAdmin]);

  const formatCpf = (v) =>
    v
      .replace(/\D/g, "")
      .slice(0, 11)
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");

  const formatCnpj = (v) => {
    const n = v.replace(/\D/g, "").slice(0, 14);
    return n
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/\.(\d{3})(\d)/, ".$1/$2")
      .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
  };

  const formatNome = (v) =>
    v
      .toLowerCase()
      .trim()
      .split(/\s+/)
      .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
      .join(" ");

  const validarCPF = (cpf) => {
    cpf = cpf.replace(/\D/g, "");
    if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf[i], 10) * (10 - i);
    let dig1 = (soma * 10) % 11;
    if (dig1 === 10) dig1 = 0;
    if (dig1 !== parseInt(cpf[9], 10)) return false;
    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf[i], 10) * (11 - i);
    let dig2 = (soma * 10) % 11;
    if (dig2 === 10) dig2 = 0;
    if (dig2 !== parseInt(cpf[10], 10)) return false;
    return true;
  };

  const validarCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/\D/g, "");
    if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(0), 10)) return false;

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }

    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== parseInt(digitos.charAt(1), 10)) return false;

    return true;
  };

  // ===== ENVIO PARA CLOUD FUNCTION =====
  const enviarEmail = async (nome, cpf, cnpj) => {

    if (!eventoId) {
      throw new Error("Evento não selecionado");
    }

    let token = null;

    let idToken = null;
    const user = auth.currentUser;

    if (user) {
      try {
        idToken = await user.getIdToken(true);
      } catch (err) {
        console.log("Erro ao obter idToken:", err);
      }
    }

    if (!isAdmin) {
      if (!window.grecaptcha || recaptchaWidgetId === null)
        throw new Error("reCAPTCHA ainda não carregado");

      try {
        token = await window.grecaptcha.execute(recaptchaWidgetId);
      } catch {
        window.grecaptcha.reset(recaptchaWidgetId);
        token = await window.grecaptcha.execute(recaptchaWidgetId);
      }
    }

    const res = await fetch(FUNCTION_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nome,
        cpf,
        cnpj,
        recaptchaToken: token,
        idToken,
        eventoId,
      }),
    });

    const data = await res.json();

    if (!res.ok || data.error)
      throw new Error(data.error || "Falha na Cloud Function");

    return data.credencial;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!cpf || !validarCPF(cpf)) {
      alert("CPF inválido.");
      return;
    }

    if (!cnpj || !validarCNPJ(cnpj)) {
      alert("CNPJ inválido.");
      return;
    }

    setLoading(true);
    setErroTermos("");

    try {
      const nomeFormatado = formatNome(nome);

      const credencial = await enviarEmail(
        nomeFormatado,
        cpf.replace(/\D/g, ""),
        cnpj.replace(/\D/g, "")
      );

      console.log("Credencial do expositor:", credencial);

      setSucesso(true);
      setNome("");
      setCpf("");
      setCnpj("");

      if (!isAdmin && window.grecaptcha && recaptchaWidgetId !== null) {
        window.grecaptcha.reset(recaptchaWidgetId);
      }
    } catch (err) {
      console.error("Erro ao cadastrar expositor:", err);
      alert(err.message);

      if (!isAdmin && window.grecaptcha && recaptchaWidgetId !== null) {
        window.grecaptcha.reset(recaptchaWidgetId);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-bg" style={{ backgroundImage: 'url("/imagens/FundoGeral.png")' }}>
      <div className="termo-wrapper">
        <div className="page">
          <h1>Cadastro de Expositor</h1>

          <div className="card">
            <form onSubmit={handleSubmit}>
              <label>CNPJ da empresa</label>

              <input
                type="text"
                placeholder="00.000.000/0000-00"
                value={cnpj}
                onChange={(e) => setCnpj(formatCnpj(e.target.value))}
                required
                disabled={loading}
              />

              <label>Nome do Vendedor</label>

              <input
                type="text"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
                disabled={loading}
              />

              <label>CPF</label>

              <input
                type="text"
                placeholder="000.000.000-00"
                value={cpf}
                onChange={(e) => setCpf(formatCpf(e.target.value))}
                required
                disabled={loading}
              />

              {erroTermos && (
                <div style={{ color: "red", marginTop: "4px" }}>
                  {erroTermos}
                </div>
              )}

              <button type="submit" disabled={loading}>
                {loading ? "Aguarde..." : "Cadastrar"}
              </button>

              {!isAdmin && <div id="recaptcha-container"></div>}
            </form>
          </div>
        </div>

        <Stepper etapaAtual={3} />
      </div>

      {sucesso && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Cadastro concluído</h2>

            <p>O expositor foi cadastrado com sucesso.</p>
            <p>Desejamos um ótimo evento e boas vendas!.</p>

            <button
              onClick={() =>
                navigate(isAdmin ? "/consulta-cadastro" : "/eventos-ativos")
              }
            >
              {isAdmin ? "Voltar ao cadastro" : "Voltar aos eventos"}
            </button>
          </div>
        </div>
      )}

      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>Aguarde um instante...</p>
        </div>
      )}
    </div>
  );
}